<template>
    <div
        class="popup"
        :class="{ shown: isPopupActive }"
    >
        <div
            class="popup-content"
            :class="{ mobile: is_collapsed }"
        >
            <font-awesome-icon
                class="icon"
                :style="{ color: popup.color }"
                :icon="popup.success ? 'check' : 'times'"
            ></font-awesome-icon>

            <div
                class="title"
                :style="{ color: popup.color }"
            >{{ popup.title }}</div>

            <div class="text">{{ popup.text }}</div>

            <div
                class="button"
                :style="{ backgroundColor: popup.color }"
                @click="hidePopup"
            >{{ popup.button }}</div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

const getters = [
    'is_collapsed',
    'isPopupActive',
    'popup',
];

const actions = [
    'hidePopup',
];

export default {
    name: 'Popup',
    computed: {
        ...mapGetters(getters),
    },
    methods: {
        ...mapActions(actions),
    },
};
</script>

<style lang="scss" scoped>
    .popup {
        width: 100%;
        height: 100vh;
        display: none;
        z-index: 99;
        position: fixed;
        top: 0;
        left: 0;
        background-color: rgba(255, 255, 255, .4);
        justify-content: center;
        align-items: center;

        &.shown {
            display: flex;
        }
    }

    .popup-content {
        background-color: #fff;
        width: 30rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        border-radius: .5rem;

        .icon {
            font-size: 2rem;
            margin: 1rem 0;

            * {
                color: inherit;
            }
        }

        .title {
            font-size: 1.4rem;
            font-weight: bold;
            margin: 0 2rem;
            text-align: center;
        }

        .text {
            font-size: 1rem;
            margin: 1rem 0;
        }

        .button {
            height: 4rem;
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            font-weight: bold;
            color: #fff;
            border-radius: 0 0 .5rem .5rem;
            cursor: pointer;
        }


        &.mobile {
            width: 90rem;

            .icon {
                font-size: 6rem;
            }

            .title {
                font-size: 5rem;
            }

            .text {
                font-size: 3.2rem;
                margin: 3rem 0;
            }

            .button {
                height: 10rem;
                font-size: 3.2rem;
                border-radius: 0 0 1.5rem 1.5rem;
            }
        }
    }
</style>
